import React, { useCallback, useEffect } from 'react';
import styles from './UIGameTradeCreatorActionButtons.module.scss';
import IconTradeBankCheck from '@static/images/icon_trade_bank_check.svg';
import { UIGameActionButton } from '../../../common/UIGameActionButton/index.ts';
import { T } from '@colonist/ui';
import { useGameStore } from '../../../store/GameStoreContext.ts';
import { ACTION_BUTTON_IDS } from '../../UIGameActionButtonsContainer/utils.ts';
import { ArrayUtils } from '@colonist/utils';
import { useCurrentStateValidator } from '../../../store/selectors/useCurrentStateValidator.ts';
import { ActionState } from '@colonist/game-states';
export const UIGameTradeCreatorActionButtonTradeWithBank = ({ tradeCreationDataValidator, getCurrentTradeCreationData, hideTooltip })=>{
    var _bankTradeError_payload;
    const myColor = useGameStore((state)=>state.myColor);
    const onClickCreateTrade = useGameStore((state)=>state.gameTrade.onClickCreateTrade);
    const setTradeError = useGameStore((state)=>state.gameTrade.setTradeError);
    const setWantedCards = useGameStore((state)=>state.gameTrade.setWantedCards);
    const setSelectedCards = useGameStore((state)=>state.gameCardInventory.setSelectedCards);
    const currentStateValidator = useCurrentStateValidator();
    const isNotMyTurn = !currentStateValidator.currentTurnPlayers.includes(myColor);
    const isSomePlayerSelectingToDiscard = currentStateValidator.isSomePlayerInActionState(ActionState.SelectCardsToDiscard);
    const tradeCreationData = getCurrentTradeCreationData(true);
    const bankTradeError = isSomePlayerSelectingToDiscard ? {
        error: {
            key: 'strings:game.errors.playersDiscarding'
        },
        payload: {
            isPlayerTradeButtonDisabled: true
        }
    } : tradeCreationDataValidator.getTradeCreationDataError(tradeCreationData);
    const isDisabled = bankTradeError != undefined && ((_bankTradeError_payload = bankTradeError.payload) === null || _bankTradeError_payload === void 0 ? void 0 : _bankTradeError_payload.isBankTradeButtonDisabled) !== false;
    const helperText = bankTradeError === null || bankTradeError === void 0 ? void 0 : bankTradeError.error;
    const beginnerSuggestionData = useGameStore((state)=>{
        var _state_gameBeginnerHint_beginnerHintData;
        return (_state_gameBeginnerHint_beginnerHintData = state.gameBeginnerHint.beginnerHintData) === null || _state_gameBeginnerHint_beginnerHintData === void 0 ? void 0 : _state_gameBeginnerHint_beginnerHintData.data;
    });
    const wantedCards = useGameStore((state)=>state.gameTrade.wantedCards);
    const offeredCards = useGameStore((state)=>state.gameCardInventory.selectedCards);
    const setBeginnerHintType = useGameStore((state)=>state.gameBeginnerHint.setBeginnerHintType);
    const setBeginnerHintData = useGameStore((state)=>state.gameBeginnerHint.setBeginnerHintData);
    const checkSuggestionFulfillment = ()=>{
        if (beginnerSuggestionData == null) return;
        if (!beginnerSuggestionData.isBankTrade) return;
        const suggestedWantedCards = beginnerSuggestionData.wantedResources;
        const suggestedOfferedCards = beginnerSuggestionData.offeredResources;
        const isWantedCardsFulfilled = ArrayUtils.arraysEqual(wantedCards.sort(), suggestedWantedCards.sort());
        const isOfferedCardsFulfilled = ArrayUtils.arraysEqual(offeredCards.sort(), suggestedOfferedCards.sort());
        const isSuggestionFulfilled = isWantedCardsFulfilled && isOfferedCardsFulfilled;
        if (isSuggestionFulfilled) {
            setBeginnerHintType('TradeBank');
        }
    };
    useEffect(()=>{
        checkSuggestionFulfillment();
    }, [
        beginnerSuggestionData,
        wantedCards,
        offeredCards
    ]);
    const handleBankTradeClick = useCallback(()=>{
        if (isDisabled) return;
        onClickCreateTrade(tradeCreationData);
        setWantedCards([]);
        setSelectedCards([]);
        setBeginnerHintType(undefined);
        setBeginnerHintData(undefined);
    }, [
        isDisabled,
        tradeCreationData
    ]);
    const handleErrorOnClick = useCallback(()=>{
        if (bankTradeError != null) {
            var _bankTradeError_payload;
            const tradeError = {
                error: bankTradeError.error
            };
            if (((_bankTradeError_payload = bankTradeError.payload) === null || _bankTradeError_payload === void 0 ? void 0 : _bankTradeError_payload.highlightCards) != null) {
                tradeError.payload = {
                    highlightCards: bankTradeError.payload.highlightCards
                };
            }
            setTradeError(tradeError);
        }
    }, [
        bankTradeError
    ]);
    if (isNotMyTurn) return null;
    return /*#__PURE__*/ React.createElement(UIGameActionButton, {
        id: ACTION_BUTTON_IDS.tradeBank,
        onClick: handleBankTradeClick,
        onClickActionIfDisabled: handleErrorOnClick,
        className: styles.actionButton,
        iconClassName: styles.icon,
        iconPath: IconTradeBankCheck,
        shakingAnimation: isDisabled,
        tooltipTitle: hideTooltip ? undefined : /*#__PURE__*/ React.createElement(T, {
            id: "strings:game.tooltips.tradeWithBank"
        }),
        disabled: isDisabled,
        helperText: helperText
    });
};
